import queryString from 'query-string'
import { RoundAPI } from './types'

export const roundApi: RoundAPI = ky => {
  return {
    async fetch() {
      return ky('round/', {
        method: 'get'
      }).json()
    },
    async patch(payload) {
      return await ky('round/', {
        method: 'patch',
        body: JSON.stringify(payload)
      }).json()
    }
  }
}
